import { render, staticRenderFns } from "./translateRevwText.vue?vue&type=template&id=1228b9cc&scoped=true"
import script from "./translateRevwText.vue?vue&type=script&lang=js"
export * from "./translateRevwText.vue?vue&type=script&lang=js"
import style0 from "./translateRevwText.vue?vue&type=style&index=0&id=1228b9cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1228b9cc",
  null
  
)

export default component.exports